<template>
    <section class="content">
        <div class="box box-info">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2" id="billNo" v-if="salesHeaderObj.reportType === 'Invoice'">
                  <label for="billNo" >Bill No :</label>
                  <span class="purchaseOutput "><b>{{salesHeaderObj.billNo}}</b></span>
              </div>
              <div class="p-field p-col-12 p-md-2" v-if="salesHeaderObj.reportType === 'Challan'">
                  <label for="challanNo" >Challan No :</label>
                  <span class="purchaseOutput "><b>{{salesHeaderObj.challanNo}}</b></span>
              </div>
              <div class="p-field p-col-12 p-md-2" v-if="salesHeaderObj.reportType === 'Order'">
                  <label for="orderNo" >Order No :</label>
                  <span class="purchaseOutput "><b>{{salesHeaderObj.orderNo}}</b></span>
              </div>
              <div class="p-field p-col-12 p-md-2" v-if="salesHeaderObj.reportType == 'Return'">
                  <label for="returnNo" >Return No :</label>
                  <span class="purchaseOutput "><b>{{salesHeaderObj.returnNo}}</b></span>
              </div>

              <div class="p-field p-col-12 p-md-2">
                    <label for="referenceNumber" >Reference No. :</label>
                    <span class="purchaseOutput ">
                      <b>{{salesHeaderObj.referenceNumber}} </b>
                    </span>
               </div>
               <div class="p-field p-col-12 p-md-2">
                  <label for="salesDate" >Date :</label>
                  <span class="purchaseOutput"><b>{{salesHeaderObj.salesDate}}</b></span>
               </div>
               <div class="p-field p-col-12 p-md-2">
                    <label for="WarehouseName" >Store :</label>
                    <span class="purchaseOutput ">
                      <b>{{salesHeaderObj.warehouse.name}} </b>
                    </span>
               </div>
               <div class="p-field p-col-12 p-md-2" v-if="salesHeaderObj.reportType === 'Invoice'">
                    <label for="WarehouseName" >Bill Type :</label>
                    <span class="purchaseOutput ">
                      <b>{{salesHeaderObj.vatTypeEnum}} </b>
                    </span>
               </div>
               <div class="p-field p-col-12 p-md-2">
                    <label for="suppplier">Customer :</label>
                    <span class="purchaseOutput ">
                      <b>{{salesHeaderObj.account.name}}</b>
                    </span>
               </div>
               <div class="p-field p-col-12 p-md-2" v-show="salesHeaderObj.account.name==='Cash'">
                    <label for="suppplier">Bill To :</label>
                    <span class="purchaseOutput ">
                      <b>{{salesHeaderObj.account.billToName}}</b>
                    </span>
               </div>
                <div class="p-field p-col-12 p-md-2" v-show="salesHeaderObj.account.name !='Cash'">
                    <label for="suppplier">Address :</label>
                    <span class="purchaseOutput ">
                      <b>{{salesHeaderObj.address}}</b>
                    </span>
               </div>
                <div class="p-field p-col-12 p-md-2" v-show="salesHeaderObj.account.name !='Cash'">
                    <label for="suppplier">Vat/Pan No :</label>
                    <span class="purchaseOutput ">
                      <b>{{salesHeaderObj.account.panNo}}</b>
                    </span>
               </div>
                <div class="p-field p-col-12 p-md-6"></div>

             </div>
               <table class="table table-bordered ">
                <thead >
                  <tr>
                    <th>SN</th>
                    <th>Item Name</th>
                    <th>Hs Code</th>
                    <th>Quantity</th>
                    <th>Rate</th>
                    <th>Amount</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody  v-for="(pd,index) in inventoryInOutDetailList " :key="index">
                  <tr>
                    <td>{{index+1}}</td>
                    <td>{{pd.name}}</td>
                    <td>{{pd.itemMaster.hsCode}}</td>
                    <td>{{pd.quantity}}</td>
                    <td>{{pd.rate}}</td>
                    <td>{{(pd.quantity * pd.rate).toFixed(4)}} </td>
                    <td>
                      <div class="p-field p-col-12 p-md-2" v-if="checkPos">
                      <Button class="p-button-raised" @click.prevent="posDetail(pd.itemMaster.id)" icon="pi pi-eye"/>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

           <div class="col-md-6" v-if="this.extraExpensesList.length>0">
             <h5>Extra Expenses:</h5>
            <table class="table table-bordered " style="margin-top: 2%;">
            <thead>
              <tr>
                <th scope="col">SN</th>
                <th scope="col">Name</th>
                <th scope="col">Amount</th>
                <th scope="col">Vatable</th>
                <th scope="col">Debit Account</th>
                <th scope="col">Credit Account</th>
              </tr>
            </thead>
            <tbody  v-for="(expenses,index) in extraExpensesList " :key="index">
              <tr>
                <td>{{index+1}}</td>
                <td>{{expenses.expensesName}}</td>
                <td>{{expenses.extraExpenseAmt}}</td>
                <td>{{expenses.applyVat}}</td>
                <td>{{expenses.debitAccountName}} </td>
                <td>{{expenses.creditAccountName}} </td>
              </tr>
            </tbody>
            </table>
          </div>
          <div class="p-grid">
          <div class="p-field p-col-12 p-md-4">
            <label >Narration</label>
            <textarea type="text" rows="6" class="form-control"  v-model="salesHeaderObj.remarks"/>
         </div>
         <div class="p-field p-col-12 p-md-4">
          <label >Amount in word</label>
          <span class="purchaseOutput ">
          <textarea type="text" rows="1" style="border: none; resize: none; width: 100%; font-size: 12px;" v-model="salesHeaderObj.amountInWords"/>
        </span>
       </div>
       </div>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-10"></div>
            <div class="p-field p-col-12 p-md-2" v-if="salesHeaderObj.reportType === 'Invoice'">
              <label for="subttotal">Subtotal: {{(salesHeaderObj.subTotalAmount).toFixed(4)}} </label>
            </div>
          </div>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-10"></div>
            <div class="p-field p-col-12 p-md-2">
              <label for="discountAmt">Discount Amt: {{(salesHeaderObj.discountAmt).toFixed(4)}}</label>
            </div>
          </div>
          <!-- <label for="exciseAmt">Excise Amt</label>
          <span id="exciseAmt" style="margin-left: 2.3em;" class="_span">{{salesHeaderObj.exciseChargeAmount}}</span>
          <br/> -->
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-10"></div>
            <div class="p-field p-col-12 p-md-2">
              <label for="nontaxable">Non-taxable:{{(salesHeaderObj.nonTaxableAmount).toFixed(4)}}</label>
            </div>
          </div>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-10"></div>
            <div class="p-field p-col-12 p-md-2">
              <label for="taxable">Taxable:{{(salesHeaderObj.taxableAmount).toFixed(4)}}</label>
            </div>
          </div>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-10"></div>
            <div class="p-field p-col-12 p-md-2">
              <label for="tax">Tax(13%):{{(salesHeaderObj.vatAmount).toFixed(4)}}</label>
            </div>
          </div>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-10"></div>
            <div class="p-field p-col-12 p-md-2">
              <label for="total">Total:{{(salesHeaderObj.totalBillAmount).toFixed(4)}}</label>
            </div>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-10"></div>
          <div class="p-field p-col-12 p-md-1">
            <Button class="p-button-raised" icon="pi pi-refresh" @click.prevent="$router.back()" label="Back"/>
          </div>
        </div>
     </div>
<div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-col-12">
     <Dialog header="Pos Detail" :closable="false"
     :visible.sync="showPosDialog" :style="{width: '50vw'}" :modal="true" :contentStyle="{'overflow': 'visible'}">
     <DataTable :value="posDetailList" :paginator="true" ref="po" :rows="8" :filters="filters" class="p-datatable-responsive p-datatable-customers"
    data-key="id" :selection.sync="selectedProduct1" selectionMode="single">
    <Column header="S.N" field=""/>
     <Column header="Bill No" :sortable="true" field="billNo" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['billNo']" />
        </template>
      </Column>
      <Column header="Customer Name" :sortable="true" field="customerName" filterMatchMode="contains">
         <template #filter>
           <InputText type="text" class="p-column-filter" v-model="filters['customerName']" />
         </template>
       </Column>
       <Column header="Contact Number" :sortable="true" field="contactNumber" filterMatchMode="contains">
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['contactNumber']" />
          </template>
        </Column>
        <Column header="Sales Qty" :sortable="true" field="salesQty" filterMatchMode="contains">
           <template #filter>
             <InputText type="text" class="p-column-filter" v-model="filters['salesQty']" />
           </template>
         </Column>
         <Column header="Selling Price" :sortable="true" field="sellingPrice"  filterMatchMode="contains" >
         <template #filter>
               <InputText type="text" class="p-column-filter" v-model="filters['sellingPrice']" />
           </template>
         </Column>
         <Column header="Total" :sortable="true" field="total" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['total']" />
            </template>
          </Column>
    </DataTable>
    <template #footer>
      <Button class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
    </template>
   </Dialog>
  </div>
</div>

    </section>
</template>
<script>
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
export default {
  name: 'salesDetailReport',
  props: ['salesHeaderObj'],
  data() {
    return {
      inventoryInOutDetailList: [],
      extraExpensesList: [],
      showPosDialog: false,
      selectedProduct1: null,
      posDetailList: [],
      filters: {}
    }
  },
  mounted() {
    this.searchInventoryOutDetail()
    this.extraExpenseList()
  },
  methods: {
    async searchInventoryOutDetail() {
      if (this.salesHeaderObj === undefined) {
        this.$router.back()
        return
      }
      let resp = await this.$store.dispatch('loadOutInventoryDetail', this.salesHeaderObj.id)
      this.inventoryInOutDetailList = resp.data.data
    },
    async extraExpenseList() {
      let resp = await this.$store.dispatch('extraExpensesSalesList', this.salesHeaderObj.id)
      if (resp !== undefined) {
        if (resp.data.status === 'SUCCESS') {
          this.extraExpensesList = resp.data.data
        }
      }
    },
    checkPos() {
      if (this.$store.getters.modules.includes(',7.')) {
        return true
      }
    },
    cancel() {
      this.showPosDialog = false
    },
    async posDetail(id) {
      let posDetail = {
        headerId: this.salesHeaderObj.id,
        itemId: id
      }
      let response = await this.$store.dispatch('posSalesDetailBySalesHeaderId', posDetail)
      if (response.data.status === 'SUCCESS') {
        this.posDetailList = response.data.data
      }
      this.showPosDialog = true
    }
  },
  components: {
    Button,
    Dialog,
    DataTable,
    Column,
    InputText
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css" >

</style>



// WEBPACK FOOTER //
// salesDetailReport.vue?32a0b24a